import { render } from "./RpcModal.vue?vue&type=template&id=616519f7&scoped=true"
import script from "./RpcModal.vue?vue&type=script&lang=js"
export * from "./RpcModal.vue?vue&type=script&lang=js"

import "./RpcModal.vue?vue&type=style&index=0&id=616519f7&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616519f7"]])

export default __exports__